<template>
  <!-- popup (s) -->
  <div class="popWrap nowOpen">
    <div class="popup">
      <div class="popContain">
        <div class="popCont full hasBtn" tabindex="-1" role="dialog">
          <div class="popHead">
            <h1 class="titH1">이전 설치 접수</h1>
          </div>
          <div class="popBody">
            <div class="popInner">
              <!-- 본문 (s) -->
              <section>
                <div class="titArea">
                  <h2 class="titH4">신청정보 입력</h2>
                </div>
                <div class="formArea">
                  <span class="label">상품선택</span>
                  <select class="ipt" ref="selectedOrderId" title="상품선택 선택" v-model="selectedOrderId" @change="changeOrderInfo($event)">
                    <option value="" selected="selected">상품을 선택해주세요</option>
                    <option :value="value.orderId" v-for="(value, key) in moveList" v-bind:key="key">
                      {{ value.orderId }}/{{ value.productName }}
                    </option>
                  </select>
                  <span class="label">이름</span>
                  <input type="text" id="ipt1_1" class="ipt" title="이름" :value="selectedMoveInfo.userName" readonly="readonly" />

                  <span class="label">연락처</span>
                  <input
                    type="tel"
                    id="phone_2"
                    class="ipt"
                    title="휴대폰 번호 입력"
                    :value="selectedMoveInfo.cellNum | phoneFormatter"
                    readonly="readonly"
                  />

                  <span class="label">철거희망일</span>
                  <datepicker
                    id="destoryDate"
                    v-model="destoryDate"
                    v-bind:format="format"
                    v-bind:disabled-dates="selectDisalbledDate"
                    v-bind:input-class="inputClass"
                    v-bind:language="lang"
                  ></datepicker>

                  <span class="label">현 설치 주소</span>
                  <div class="setAddr">
                    <input
                      type="tel"
                      id="addr_11"
                      class="ipt"
                      title="설치 주소 입력 (우편번호)"
                      placeholder="우편번호"
                      :value="selectedMoveInfo.addrPost"
                      readonly="readonly"
                    />
                    <button type="button" class="btn_g m" disabled="disabled">우편번호찾기</button>
                  </div>
                  <input
                    type="text"
                    id="addr_21"
                    class="ipt"
                    placeholder="기본주소"
                    title="설치 주소 입력 (기본주소)"
                    :value="selectedMoveInfo.addrRoad"
                    readonly="readonly"
                  />
                  <input
                    type="text"
                    id="addr_31"
                    class="ipt"
                    placeholder="상세주소"
                    title="설치 주소 입력 (상세주소)"
                    :value="selectedMoveInfo.addrRemark"
                    readonly="readonly"
                  />

                  <span class="label">철거 시 요청사항</span>
                  <textarea class="ipt" title="철거 시 요청사항 입력" placeholder="요청사항을 입력해주세요. (100자)" v-model="asUserMemo2"></textarea>

                  <span class="label">이전설치희망일</span>
                  <datepicker
                    id="changeDate"
                    v-model="changeDate"
                    v-bind:format="format"
                    v-bind:disabled-dates="selectDisalbledDate"
                    v-bind:input-class="inputClass"
                    v-bind:language="lang"
                  ></datepicker>

                  <span class="label">이전설치 주소</span>
                  <div class="setAddr">
                    <input
                      type="tel"
                      id="addr_1"
                      class="ipt"
                      title="설치 주소 입력 (우편번호)"
                      placeholder="우편번호"
                      value="03142"
                      readonly="readonly"
                      v-model="installInfo.addrPost"
                    />
                    <button type="button" class="btn_g m" @click="addrPopupOpen">우편번호찾기</button>
                  </div>
                  <input
                    type="text"
                    id="addr_2"
                    class="ipt"
                    placeholder="기본주소"
                    title="설치 주소 입력 (기본주소)"
                    readonly="readonly"
                    v-model="installInfo.addrRoad"
                  />
                  <input
                    type="text"
                    id="addr_3"
                    class="ipt"
                    ref="addrDetail"
                    placeholder="상세주소"
                    title="설치 주소 입력 (상세주소)"
                    v-model="installInfo.addrDetail"
                  />

                  <span class="label">이전설치 시 요청사항</span>
                  <textarea
                    class="ipt"
                    title="이전설치 시 요청사항 입력"
                    placeholder="요청사항을 입력해주세요. (100자)"
                    v-model="asUserMemo"
                  ></textarea>
                </div>

                <div class="orderSum">
                  <ul class="infoList">
                    <li>
                      <span class="item" style="width:35%">결제금액</span>
                      <span class="val">
                        <span class="money">
                          <em>130,000</em>
                          원
                        </span>
                        <p class="txtXS pointC6 ar mt0">* 철거비 60,000원 + 이전설치비 70,000원</p>
                      </span>
                    </li>
                  </ul>
                </div>
              </section>
              <!-- 본문 (e) -->

              <section class="hr">
                <div class="titArea">
                  <h2 class="titH4">결제수단 선택</h2>
                </div>

                <div class="formArea">
                  <ul class="iptGroup iptBtn">
                    <li>
                      <input type="radio" class="ipt" name="rdosort" id="btn_1" checked="checked" />
                      <label for="btn_1"><span class="ico">카드결제</span></label>
                    </li>
                  </ul>

                  <span class="label">카드선택</span>
                  <select class="ipt" ref="cardName" title="카드선택" v-model="cardName">
                    <option value="" selected="selected">선택해주세요</option>
                    <option v-for="(option, key) in cardList" v-bind:value="option.code" v-bind:key="key">
                      {{ option.codeName }}
                    </option>
                  </select>

                  <span class="label">카드번호</span>

                  <div class="transkey">
                    <div class="setCard">
                      <input
                        type="tel"
                        class="ipt"
                        ref="cardNum1"
                        maxlength="4"
                        title="카드번호 첫번째 4자리"
                        id="cardNum1"
                        v-model="cardNum1"
                        nextTarget="cardNum2"
                        v-onlyNum
                        v-skipOfMax
                        value=""
                      />
                      <span class="sign" aria-hidden="true">-</span>
                      <input
                        type="tel"
                        class="ipt"
                        ref="cardNum2"
                        maxlength="4"
                        v-model="cardNum2"
                        id="cardNum2"
                        nextTarget="cardNum3"
                        v-skipOfMax
                        title="카드번호 두번째 4자리"
                        v-onlyNum
                        value=""
                      />
                      <span class="sign" aria-hidden="true">-</span>
                      <input
                        type="tel"
                        class="ipt"
                        maxlength="4"
                        id="cardNum3"
                        nextTarget="cardNum4"
                        title="카드번호 세번째 4자리"
                        v-skipOfMax
                        data-tk-kbdType="number"
                        onfocus="mtk.onKeyboard(this); this.scrollIntoView(); this.scrollIntoView();"
                      />
                      <span class="sign" aria-hidden="true">-</span>
                      <input
                        type="tel"
                        class="ipt"
                        maxlength="4"
                        id="cardNum4"
                        title="카드번호 마지막 4자리"
                        data-tk-kbdType="number"
                        onfocus="mtk.onKeyboard(this); this.scrollIntoView();"
                      />
                    </div>
                  </div>
                  <span class="label">유효기간</span>
                  <div class="transkey">
                    <div class="setPeriod">
                      <input
                        type="tel"
                        class="ipt"
                        maxlength="2"
                        id="expirdateMM"
                        nextTarget="expirdateYY"
                        title="유효기간 월 2자리"
                        placeholder="MM"
                        v-skipOfMax
                        data-tk-kbdType="number"
                        onfocus="mtk.onKeyboard(this); this.scrollIntoView();"
                      />
                      <span class="sign" aria-hidden="true">/</span>
                      <input
                        type="tel"
                        class="ipt"
                        maxlength="2"
                        id="expirdateYY"
                        title="유효기간 년 2자리"
                        placeholder="YY"
                        data-tk-kbdType="number"
                        onfocus="mtk.onKeyboard(this); this.scrollIntoView();"
                      />
                    </div>
                  </div>

                  <span class="label">비밀번호</span>
                  <div class="transkey">
                    <div class="setPw">
                      <input
                        type="password"
                        class="ipt"
                        id="password"
                        maxlength="2"
                        title="비밀번호 앞 2자리"
                        placeholder="앞 2자리"
                        data-tk-kbdType="number"
                        onfocus="mtk.onKeyboard(this); this.scrollIntoView();"
                      />
                      <input type="password" class="ipt" maxlength="2" title="비밀번호 뒤 2자리" value="**" readonly="readonly" />
                    </div>
                  </div>

                  <span class="label">생년월일</span>
                  <div class="setBirth">
                    <input
                      type="tel"
                      class="ipt"
                      ref="yyyy"
                      id="yyyy"
                      maxlength="4"
                      title="생년월일 년도 4자리"
                      placeholder="1990"
                      v-model="yyyy"
                      nextTarget="mm"
                      v-onlyNum
                      v-skipOfMax
                    />
                    <span class="sign" aria-hidden="true">/</span>
                    <input
                      type="tel"
                      class="ipt"
                      ref="mm"
                      id="mm"
                      maxlength="2"
                      title="생년월일 월 2자리"
                      placeholder="01"
                      v-model="mm"
                      nextTarget="dd"
                      v-onlyNum
                      v-skipOfMax
                    />
                    <span class="sign" aria-hidden="true">/</span>
                    <input type="tel" ref="dd" class="ipt" id="dd" maxlength="2" title="생년월일 일 2자리" placeholder="01" v-model="dd" v-onlyNum />
                  </div>

                  <span class="singleIpt mt20">
                    <input type="checkbox" ref="authChk" class="ipt" name="jqscroll_chk" id="jqscroll_chk" v-model="authChk" />
                    <label for="jqscroll_chk">결제할 항목의 금액정보를 확인했으며 이에 동의합니다. (전자상거래법 제8조2항)</label>
                  </span>

                  <!--<p class="fieldMsg error" id="idMsg">카드정보가 올바르지 않습니다 다시 입력해주세요.</p>
                  <p class="fieldMsg error" id="idMsg">신청자와 카드 명의자가 일치하지 않습니다.</p>
                  <p class="fieldMsg error" id="idMsg">결제내용에 동의해주세요.</p>
                  <p class="fieldMsg error" id="idMsg">결제 정보에 오류가 있습니다. 다시 확인해주세요.</p>-->
                </div>
              </section>
            </div>
          </div>

          <div class="btnArea sticky">
            <button type="button" class="btn_p" @click="putAsMove">접수</button>
          </div>

          <button type="button" class="btnIco_close" @click="$emit('close')"><span>팝업 닫기</span></button>
        </div>
      </div>
    </div>
    <FindAddr v-if="findAddr" @callback="selectAddr" @close="close"></FindAddr>
    <MessagePop v-if="messagePop" @close="close">
      <p v-html="msg"></p>
    </MessagePop>
    <ProgressBar ref="progress"></ProgressBar>
  </div>
  <!-- popup (e) -->
</template>
<script>
import ApiService from '@/common/api.service';
import $ from 'jquery';
import * as customjs from '@/../static/js/m.front.js';
import FindAddr from '@/components/comm/FindAddr';
import MessagePop from '@/components/popup/MessagePop';
import Datepicker from 'vuejs-datepicker';
import { ko } from 'vuejs-datepicker/dist/locale';
import { isEmpty } from '@/common/common.function';
import moment from 'moment';
import JwtService from '@/common/jwt.service';
import ProgressBar from '@/views/app/comm/ProgressBar';

export default {
  name: 'changeInstallinfoInsertPop',
  components: {
    MessagePop,
    FindAddr,
    Datepicker,
    ProgressBar,
  },
  mounted() {
    if (JwtService.getToken()) this.userId = JwtService.getUserInfo().userId;
    customjs.init();
    $('body').addClass('popOn');
    this.moveTargetListInit();
    this.optionInit();
    if (process.env.NODE_ENV != 'dev') {
      import('@/raon/welcomeTranskey').then(m => {
        m.importCSS();
        m.importJS(0, ['cardNum3', 'cardNum4', 'expirdateMM', 'expirdateYY', 'password']);
      });
    }
  },
  data() {
    return {
      authChk: false,
      doneChk: false,
      moveList: [],
      selectedOrderId: '',
      selectedMoveInfo: [],

      msg: '',
      messagePop: false,
      findAddr: false,

      yyyy: '',
      mm: '',
      dd: '',

      cardList: [],
      cardName: '',
      cardPwd: null,
      cardNum1: null,
      cardNum2: null,
      //cardNum3: null,
      //cardNum4: null,
      expirdateYY: null,
      expirdateMM: null,

      cardNumber: '',
      //cardExpireDate: '',

      destoryDate: '',
      changeDate: '',
      selectDisalbledDate: {
        to: this.getAddMinDate(),
        days: [6, 0],
      },
      format: 'yyyy - MM - dd',
      inputClass: 'ipt date notDel uiAct hasDatepicker',
      calendarClass: 'ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all',
      lang: ko,
      flag: true,

      asUserMemo: '', //이전
      asUserMemo2: '', //철거

      installInfo: {
        addrPost: '',
        addrRoad: '',
        addrCode: '',
        addrJibun: '',
        addrDetail: '',
      },
    };
  },
  watch: {
    cardNum1: function() {
      this.cardNumber = this.cardNum1 + this.cardNum2;
    },
    cardNum2: function() {
      this.cardNumber = this.cardNum1 + this.cardNum2;
    },
    // cardNum3: function() {
    //   this.cardNumber = this.cardNum1 + this.cardNum2 + this.cardNum3 + this.cardNum4;
    // },
    // cardNum4: function() {
    //   this.cardNumber = this.cardNum1 + this.cardNum2 + this.cardNum3 + this.cardNum4;
    // },
    // expirdateMM: function() {
    //   this.cardExpireDate = this.expirdateMM + this.expirdateYY;
    // },
    // expirdateYY: function() {
    //   this.cardExpireDate = this.expirdateMM + this.expirdateYY;
    // },
  },
  computed: {
    ssnVal: function() {
      return this.yyyy.substring(2) + this.mm + this.dd;
    },
  },
  methods: {
    addrPopupOpen: function() {
      this.findAddr = true;
    },
    selectAddr: function(data) {
      this.installInfo.addrPost = data.zip;
      this.installInfo.addrRoad = data.nadr1;
      this.installInfo.addrCode = data.nnmb;
      this.installInfo.addrJibun = data.adr1;
      this.close();
    },
    getAddMinDate: function() {
      let today = new Date();
      // today.setDate(today.getDate() - 1);
      return today;
    },
    moveTargetListInit: function() {
      ApiService.service('GET', '/service/auth/as/moveTargetList')
        .then(({ data }) => {
          this.moveList = data.result;
          this.$refs.selectedOrderId.focus();
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });
    },
    changeOrderInfo: function(data) {
      console.log(data.target.value);
      for (let value of this.moveList) {
        if (value.orderId == data.target.value) {
          if (value.isAsMoveYn == 'Y') {
            if (value.cellNum === null || value.cellNum === undefined || value.cellNum === '') {
              this.selectedMoveInfo = value;
              this.selectedMoveInfo.cellNum = value.telfldnbr;
            } else {
              this.selectedMoveInfo = value;
            }
          } else {
            let addStr = /*value.registeredYn == 'Y' && !isEmpty(value.telfldnbr) ?  value.telfldnbr : */ '1670-0202';
            this.msg =
              '<p>죄송합니다. 선택하신 제품은 앱 상에서 <br>이전설치 접수 기능을 제공하지 않습니다. <br>웰릭스렌탈 고객센터로 문의해주세요.</p><p class="mt10">' +
              // value.vendorName +
              '대표번호 ' +
              addStr +
              '</p>';

            setTimeout(() => {
              this.messagePop = true;
            }, 100);
            this.selectedOrderId = '';
            this.selectedMoveInfo = [];
          }
        }
      }
      console.log(this.selectedMoveInfo);
    },
    optionInit: function() {
      ApiService.service('GET', '/common/code/RCAD', {
        params: '',
      })
        .then(({ data }) => {
          for (let item of data.result) {
            if (item.codePrefix == 'RCAD') {
              this.cardList = item.codeList;
            }
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });
    },
    close() {
      this.messagePop = false;
      this.findAddr = false;
      if (this.doneChk) this.$emit('close');
    },
    validate: function() {
      if (this.selectedOrderId == '') {
        this.msg = '상품을 선택해주세요.';
        setTimeout(() => {
          this.messagePop = true;
        }, 100);
        this.$refs.selectedOrderId.focus();
        return false;
      }
      if (this.destoryDate.length < 1) {
        this.msg = '철거 희망일을 선택해주세요.';
        setTimeout(() => {
          this.messagePop = true;
        }, 100);
        document.getElementById('destoryDate').focus();
        return false;
      }
      if (this.changeDate.length < 1) {
        this.msg = '이전 설치 희망일을 선택해주세요.';
        setTimeout(() => {
          this.messagePop = true;
        }, 100);
        document.getElementById('changeDate').focus();
        return false;
      }
      if (isEmpty(this.installInfo.addrDetail)) {
        this.msg = '주소를 입력해주세요.';
        setTimeout(() => {
          this.messagePop = true;
        }, 100);
        this.$refs.addrDetail.focus();
        return false;
      }
      if (this.cardName == '') {
        this.msg = '카드를 선택해주세요.';
        setTimeout(() => {
          this.messagePop = true;
        }, 100);
        this.$refs.cardName.focus();
        return false;
      }
      if (isEmpty(this.cardNum1)) {
        this.msg = '카드번호를 입력해주세요.';
        this.messagePop = true;
        this.$refs.cardNum1.focus();
        return false;
      }
      if (isEmpty(this.cardNum2)) {
        this.msg = '카드번호를 입력해주세요.';
        this.messagePop = true;
        this.$refs.cardNum2.focus();
        return false;
      }
      if (isEmpty(this.yyyy)) {
        this.msg = '생년월일을 입력해주세요.';
        setTimeout(() => {
          this.messagePop = true;
        }, 100);
        this.$refs.yyyy.focus();
        return false;
      }
      if (isEmpty(this.mm)) {
        this.msg = '생년월일을 입력해주세요.';
        setTimeout(() => {
          this.messagePop = true;
        }, 100);
        this.$refs.mm.focus();
        return false;
      }
      if (isEmpty(this.dd)) {
        this.msg = '생년월일을 입력해주세요.';
        setTimeout(() => {
          this.messagePop = true;
        }, 100);
        this.$refs.dd.focus();
        return false;
      }
      if (this.mm > 12) {
        this.msg = '잘못된 생년월일입니다.';
        setTimeout(() => {
          this.messagePop = true;
        }, 100);
        this.$refs.mm.focus();
        return false;
      }
      if (this.dd > 31) {
        this.msg = '잘못된 생년월일입니다.';
        setTimeout(() => {
          this.messagePop = true;
        }, 100);
        this.$refs.dd.focus();
        return false;
      }
      if (!this.authChk) {
        this.msg = '약관에 동의해주세요.';
        setTimeout(() => {
          this.messagePop = true;
        }, 100);
        this.$refs.authChk.focus();
        return false;
      }

      return true;
    },
    putAsMove: function() {
      console.log(moment(this.changeDate).format('yyyyMMDD'));
      if (!this.validate()) {
        return;
      }
      console.log(this.makeData('cardNum3'));

      this.$refs.progress.loadingStart();
      ApiService.service('POST', '/service/auth/asMove', {
        request: {
          orderId: this.selectedOrderId,
          asUserMemo2: this.asUserMemo2, // 철거 요청사항
          rtnReqDate: moment(this.destoryDate).format('yyyyMMDD'), // 철거희망일
          istAddrCode: this.installInfo.addrCode, // 이전설치 우편번호
          rtnAddrRemark: this.installInfo.addrDetail, // 이전설치 상세주소
          asUserMemo: this.asUserMemo, // 이전설치 요청 사항
          istReqDate: moment(this.changeDate).format('yyyyMMDD'), // 이전설치 희망일
          userId: this.userId,

          istAddrPost: this.installInfo.addrPost,
          istAddrJibun: this.installInfo.addrJibun,
          istAddrRoad: this.installInfo.addrRoad,

          // 결재정보
          cardName: this.cardName,
          cardNumber: this.cardNumber,
          cardNum3: this.makeData('cardNum3', 'Y'),
          cardNum4: this.makeData('cardNum4', 'Y'),
          // cardExpireDate: this.cardExpireDate,
          cardExpireMM: this.makeData('expirdateMM', 'Y'),
          cardExpireYY: this.makeData('expirdateYY', 'Y'),
          cardExpireMMStr: document.getElementById('expirdateMM').value,
          cardExpireYYStr: document.getElementById('expirdateYY').value,
          cardNumberStr: this.cardNumber + document.getElementById('cardNum3').value + document.getElementById('cardNum4').value,
          cardPwd: this.makeData('password', 'Y'),
          cardSsn: this.ssnVal,

          /*
            asUserMemo: this.asUserMemo, // 이전설치 요청 사항
            asUserMemo2: this.asUserMemo2, // 철거 요청사항
            cardName: this.cardName,
            cardNumber: this.cardNumber,
            cardExpireDate: this.cardExpireDate,
            cardPwd: this.cardPwd,
            cardSsn: this.ssnVal,
            istAddrCode: '',
            istAddrCode: this.installInfo.addrPost,
            istAddrJibun: this.installInfo.addrJibun,
            istAddrPost: this.installInfo.addrPost,
            istAddrRoad: this.installInfo.addrRoad,
            rtnAddrRemark: this.installInfo.addrDetail,
            rtnAddrRemark: this.installInfo.addrRemark,
            */
        },
        serviceType: 'app',
      })
        .then(({ data }) => {
          console.log(data);
          if (data.isSucceed) {
            const params = {};
            // //const appsFlyerParams = JSON.stringify(params);
            window.appsFlyer('af_complete_removal_application', params);
            this.doneChk = true;
            this.msg = '결제가 완료되어 이전설치가<br>접수되었습니다.';
            setTimeout(() => {
              this.messagePop = true;
            }, 100);
          } else {
            this.msg = data.error;
            this.messagePop = true;
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        })
        .finally(() => {
          this.$refs.progress.loadingEnd();
        });
    },
    makeData(id, encrytedYN, plainValue) {
      if (process.env.NODE_ENV == 'dev') return null;
      // eslint-disable-next-line no-undef
      let values = mtk.inputFillEncData(document.getElementById(id));
      let name = document.getElementById(id).name;
      let hidden = values.hidden;
      let hmac = values.hmac;

      // eslint-disable-next-line no-undef
      let keyboardType = transkey[id].keyboard;
      // eslint-disable-next-line no-undef
      let keyIndex = transkey[id].keyIndex;
      // eslint-disable-next-line no-undef
      let fieldType = transkey[id].fieldType;
      let seedKey = document.getElementById('seedKey').value;
      let initTime = document.getElementById('initTime').value;
      let ExE2E = values.ExE2E;

      let newRaonRequest = {};
      newRaonRequest.id = id;
      newRaonRequest.name = name;
      newRaonRequest.keyboardType = keyboardType;
      newRaonRequest.keyIndex = keyIndex;
      newRaonRequest.fieldType = fieldType;
      newRaonRequest.seedKey = seedKey;
      newRaonRequest.initTime = initTime;
      newRaonRequest.transkey = hidden;
      newRaonRequest.transkey_HM = hmac.toString();
      newRaonRequest.transkey_EXE2E = ExE2E;
      newRaonRequest.plainValue = plainValue;
      newRaonRequest.encrytedYN = encrytedYN;

      return newRaonRequest;
    },
  },
};
</script>
